var exports = {
  "U": "xf61da738--6894f8--buttons",
};

module.exports = exports;
